import React from 'react';
import PermissionGuard from '../components/auth/PermissionGuard';
import { permissions } from '../config/permissions';
import Roles from '../sections/roles';

const RolesPage = () => {
  return (
    <PermissionGuard permissions={[permissions.MANAGE_USERS]}>
      <Roles />
    </PermissionGuard>
  );
};

export default RolesPage;
